import {
  last_transaction_selection,
  promocode_options_selection,
} from './get_customer_last_transaction_promocodes_data';

export const customer_amount_first_selection = `
      pin
      first_name
      last_name
      full_name
      zip
      country
      address
      city
      state
      ip_address
      dob
      language
      profile
      email_customer
      phone_customer
`;

export const available_currencies_selection = `
      base_currency
      currencies {
        code
        label
        min_amount
        max_amount
        rate
        crypto
        spread_rate
        has_payment_method_without_fee
        fees {
          flat_fee_amount
          percentage_fee
          is_included
          min_transaction_amount
          max_transaction_amount
          min_fee_amount
          max_fee_amount
        }
      }
`;

export const get_customer_available_currencies_promocode_last_transaction_query = `
  query Get_customer_available_currencies_promocode_last_transaction_data ($active_intent: CashierIntent) {
    customer {${customer_amount_first_selection}}
    available_currencies(active_intent: $active_intent) {${available_currencies_selection}}
    last_transaction(active_intent: $active_intent) {${last_transaction_selection}}
    promocode_options {${promocode_options_selection}}
  }
`;
